module.exports = __webpack_public_path__ + "fa321fc47f05285cb6fb85855b7bd4e8.svg";